import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';

import { StatesAbbreviation } from '../../utils/enums';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

const VoteRegistrationSuccessMultiActionsCard = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent titleNoRep={props.title} />}
            {...props}
        />
    </TransitionContainerNoExit>
);

VoteRegistrationSuccessMultiActionsCard.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

export default connect(
    state => ({
        title:
            state.voteRegistration.successInfo.reason === 'underAge'
                ? 'Unfortunately, you must be 18 years or older in order to vote.'
                : state.voteRegistration.successInfo.reason === 'isRegisterOnline'
                ? 'Congrats on choosing to register to vote.'
                : state.voteRegistration.successInfo.reason === 'isRegisterComplete'
                ? 'Thanks! You’re not quite done yet.'
                : !state.voteRegistration.completeVoteRegistration.message
                ? 'Sorry, your state does not support online voter verification.'
                : '',
        thankYouText:
            state.voteRegistration.successInfo.reason === 'underAge'
                ? 'You can still #TakeAction and make your voice heard by using Action Button. Visit <a href="http://actionbutton.org" target="_blank">actionbutton.org</a> to get started.'
                : state.voteRegistration.successInfo.reason === 'isRegisterOnline'
                ? `The ${
                      StatesAbbreviation[state.voteRegistration.formData.stateId]
                  } state website will let you register completely online!`
                : state.voteRegistration.successInfo.reason === 'isRegisterComplete'
                ? `Your voter <a target="_blank" href="${
                      state.voteRegistration.completeVoteRegistration.pdfUrl
                  }">registration forms are complete</a>, but you still need to sign and mail them to the address located on the form. We've also emailed the form to the address you gave us so you have access to it later.`
                : state.voteRegistration.completeVoteRegistration.message || ''
    }),
    {}
)(VoteRegistrationSuccessMultiActionsCard);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationSuccessMultiActionsCard.jsx